import { UTF_16 } from '../../utils/UTF_16.js';
import { decodeText } from '../../utils/decodeText.js';
import { getElementsByName } from '../../xml/getElementsByName.js';
import { parseXml } from '../../xml/parseXml.js';
import { CONTENT_TYPE } from '../common/CONTENT_TYPE.js';
import { HTTP_HEADERS } from '../common/HTTP_HEADERS.js';
import { TEXT_XML_UTF8 } from '../common/TEXT_XML_UTF8.js';
/**
 * Gets the PlayReady license request headers from the MediaKeyMessageEvent.
 *
 * @param message - An ArrayBuffer from the content decryption module.
 * @param encoding - The message encoding type. Default is UTF-16.
 * @returns Request headers.
 *
 * @group DRM
 * @beta
 *
 * @example
 * {@includeCode ../../../test/drm/playready/getRequestHeadersFromMessage.test.ts#example}
 */
export function getRequestHeadersFromMessage(message, encoding = UTF_16) {
    var _a, _b, _c, _d, _e;
    const headers = {};
    // If message format configured/defaulted to utf-16 AND number of bytes is odd,
    // assume 'unwrapped' raw CDM message.
    if (encoding === UTF_16 && message && message.byteLength % 2 === 1) {
        headers[CONTENT_TYPE] = TEXT_XML_UTF8;
        return headers;
    }
    const msg = decodeText(message, { encoding });
    const xml = parseXml(msg);
    const httpHeaders = (_a = getElementsByName(xml, HTTP_HEADERS)[0]) === null || _a === void 0 ? void 0 : _a.childNodes;
    if (!httpHeaders) {
        return headers;
    }
    for (const header of httpHeaders) {
        const name = (_c = (_b = getElementsByName(header, 'name')[0]) === null || _b === void 0 ? void 0 : _b.childNodes[0]) === null || _c === void 0 ? void 0 : _c.nodeValue;
        const value = (_e = (_d = getElementsByName(header, 'value')[0]) === null || _d === void 0 ? void 0 : _d.childNodes[0]) === null || _e === void 0 ? void 0 : _e.nodeValue;
        if (name && value) {
            headers[name] = value;
        }
    }
    // Some versions of the PlayReady CDM return 'Content' instead of 'Content-Type'.
    // This does not adhere to the W3C spec and license servers may reject the request.
    if (headers.hasOwnProperty('Content')) {
        headers[CONTENT_TYPE] = headers['Content'];
        delete headers['Content'];
    }
    // Set 'Content-Type' header by default if not provided in the the CDM message
    // or if the message is unwrapped.
    if (!headers.hasOwnProperty(CONTENT_TYPE)) {
        headers[CONTENT_TYPE] = TEXT_XML_UTF8;
    }
    return headers;
}
//# sourceMappingURL=getRequestHeadersFromMessage.js.map